module.exports = __webpack_public_path__ + "img/data_yh.81b60f1e.png";